module.exports = __webpack_public_path__ + "static/media/Instagram.76b740f9.png";